import { Route, Routes, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AppLogin } from "../app/loginApp/AppLogin";
import {LoadPage} from '../app/loginApp/pages/LoadPage'
import {AppApplicationSelector} from "../app/aplicationSelector/AppApplicationSelector"
/* == HOOKS == */
import { useAuth } from "../hooks";
import { ServeRoute, UserTokenKey, AUTHENTICATED_STATES } from "../Constants";
import Swal from "sweetalert2";


export const AppRoute = () => {
  const { status, errorMessage } = useAuth();

  useEffect(() => {
    if (errorMessage) {
      Swal.fire("Error", errorMessage, "error");
    }
  }, [errorMessage]);

  return (
    <div className="m-0 p-0">
      <Routes>
        {status === AUTHENTICATED_STATES.AUTHENTICATED ? (
          <>
            <Route path={`${ServeRoute}/*`} element={<AppApplicationSelector/>} />
            <Route
              path={`${ServeRoute}/*`}
              element={<Navigate to={`${ServeRoute}`} />}
            />
          </>
        ) : status === AUTHENTICATED_STATES.NOTAUTHENTICATED ? (
          <>
            <Route path={`${ServeRoute}/*`} element={<AppLogin />} />
            {!localStorage.getItem(UserTokenKey) && (
              <Route
                path={`${ServeRoute}/*`}
                element={<Navigate to={`${ServeRoute}`} />}
              />
            )}
          </>
        ) : status === AUTHENTICATED_STATES.CHECKING ? (
          <>
            <Route path={`${ServeRoute}/*`} element={<LoadPage/>}/>
            <Route
              path={`${ServeRoute}/*`}
              element={<Navigate to={`${ServeRoute}`} />}
            />
          </>
        ) : (
          <></>
        )}
      </Routes>
    </div>
  );
};
